import { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { useParams } from "react-router-dom";
import './SchoolList.css';
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const EnquiryDetail = () => {
    const [schools, setSchools] = useState([]);
    const [loading, setLoading] = useState(true);
    const { school_slug } = useParams();
    const [galleryImages, setGalleryImages] = useState([]);
    const schoolSlugs = JSON.parse(localStorage.getItem("school_slugs")) || [];
    const firstSlug = schoolSlugs.length > 0 ? schoolSlugs[0] : "";
    

    const [filters, setFilters] = useState({
        school_names: [],
        from_date: "",
        to_date: ""
    });

    useEffect(() => {
        const loadSchools = async () => {
            setLoading(true);
            try {
                const res = await axios.get(
                    `${baseAPIUrl}admin/general_settings/get_schools/`,
                    { withCredentials: true }
                );

                if (res.data.status === 1 && res.data.data) {
                    const schoolList = res.data.data;
                    setSchools(schoolList);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        loadSchools();
    }, [school_slug]);

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchContent(filters);
    }, []);

    const fetchContent = async (filters = {}) => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/general_settings/get_all_enquiries`,
                {
                    params: filters,
                    withCredentials: true
                }
            );

            if (res.data.status === 1) {
                setGalleryImages(res.data.data || []);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        { name: "School Name", selector: row => row.school_name, sortable: true },
        { name: "Class", selector: row => row.class, sortable: true },
        { name: "Full Name", selector: row => row.full_name, sortable: true },
        { name: "Parent Name", selector: row => row.parent_name },
        { name: "Contact No", selector: row => row.contact_no },
        { name: "Email", selector: row => row.email },
        { name: "State", selector: row => row.state },
        { name: "City", selector: row => row.city },
        { name: "Time", selector: row => row.timestamp, sortable: true }
    ];

    const downloadExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(galleryImages);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Enquiries");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        const data = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(data, "Enquiries.xlsx");
    };



    if (loading) return <p>Loading...</p>;
    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Enquiries</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href={`/admin/enquiry-dashboard/${firstSlug}`}>Dashboard</a></li>
                                <li class="breadcrumb-item active">Enquiries</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                    <form>
                        <div className="row mb-2">

                            <div className="col-md-4">
                                <label>Select School</label>
                                <Select
                                    isMulti
                                    options={schools.map(s => ({
                                        value: s.school_name,
                                        label: s.school_name
                                    }))}
                                    value={filters.school_names.map(name => ({
                                        value: name,
                                        label: name
                                    }))}
                                    onChange={(selected) => {
                                        const values = selected ? selected.map(s => s.value) : [];

                                        const updatedFilters = {
                                            ...filters,
                                            school_names: values
                                        };

                                        setFilters(updatedFilters);
                                        fetchContent(updatedFilters);
                                    }}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            width: '100%',
                                            padding: '3.5px',
                                            border: '2px solid rgb(100, 19, 32)',
                                            borderRadius: '5px',
                                            fontSize: '0.9rem',
                                            fontFamily: 'Lora',
                                            color: '#000',
                                            backgroundColor: 'white',
                                            cursor: 'pointer',
                                            boxShadow: 'none'
                                        }),
                                        multiValue: (base) => ({
                                            ...base,
                                            backgroundColor: 'rgb(100, 19, 32)',
                                            color: '#fff'
                                        }),
                                        multiValueLabel: (base) => ({
                                            ...base,
                                            color: '#fff'
                                        }),
                                        multiValueRemove: (base) => ({
                                            ...base,
                                            color: '#fff',
                                            ':hover': {
                                                backgroundColor: '#fff',
                                                color: 'rgb(100, 19, 32)'
                                            }
                                        })
                                    }}
                                />



                            </div>{/* /.col */}
                            <div className="col-md-8">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>From date:</label>
                                            <input
                                                type="date"
                                                value={filters.from_date}
                                                onChange={(e) => {
                                                    const updatedFilters = {
                                                        ...filters,
                                                        from_date: e.target.value
                                                    };

                                                    setFilters(updatedFilters);
                                                    fetchContent(updatedFilters);
                                                }}
                                                style={{
                                                    width: '100%',
                                                    padding: '10px',
                                                    border: '2px solid rgb(100, 19, 32)',
                                                    borderRadius: '5px',
                                                    fontSize: '0.9rem',
                                                    fontFamily: 'Lora',
                                                    color: '#000',
                                                    backgroundColor: 'white',
                                                    cursor: 'pointer'
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>To date:</label>
                                            <input
                                                type="date"
                                                value={filters.to_date}
                                                onChange={(e) => {
                                                    const updatedFilters = {
                                                        ...filters,
                                                        to_date: e.target.value
                                                    };

                                                    setFilters(updatedFilters);
                                                    fetchContent(updatedFilters);
                                                }}
                                                style={{
                                                    width: '100%',
                                                    padding: '10px',
                                                    border: '2px solid rgb(100, 19, 32)',
                                                    borderRadius: '5px',
                                                    fontSize: '0.9rem',
                                                    fontFamily: 'Lora',
                                                    color: '#000',
                                                    backgroundColor: 'white',
                                                    cursor: 'pointer'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>{/* /.col */}

                        </div>{/* /.row */}
                    </form>
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h5>Enquiry List</h5>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <button
                                                className="btn btn-success"
                                                onClick={downloadExcel}
                                            >
                                                Download Excel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <DataTable
                                        columns={columns}
                                        data={galleryImages}
                                        pagination
                                        highlightOnHover
                                        striped
                                        responsive
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div >
    )
}
export default EnquiryDetail;